var anchors = document.getElementsByClassName('crystal-container');
for(var i = 0; i < anchors.length; i++) {
	var anchor = anchors[i];
	anchor.onclick = function(e) {
		document.getElementById(e.currentTarget.dataset.id).style.display = 'block';
	}
}

var anchors = document.getElementsByClassName('crystal-close');
for(var i = 0; i < anchors.length; i++) {
	var anchor = anchors[i];
	anchor.onclick = function(e) {
		document.getElementById(e.currentTarget.dataset.id).style.display = 'none';
	}
}



/* Star Cursor */
if ( custom_cursor == true ) {
	class t {
		constructor(t) {
			this.bindAll(this, ["resize", "move", "touch", "draw"]),
			(this.colors = t.colors),
			(this.D = document),
			(this.W = window),
			(this.container = t.el),
			(this.time = t.time),
			(this.char = t.character),
			(this.particles = []),
			this.init();
		}
		hasTouch() {
			var t = "ontouchstart" in this.D,
			e = navigator.msMaxTouchPoints && navigator.msMaxTouchPoints > 1,
			i = !!this.W.navigator.msPointerEnabled;
			return t || e || i;
		}
		init() {
			this.resize(), this.events(), this.draw();
		}
		events() {
			this.W.addEventListener("resize", this.resize), this.hasTouch() ? (this.D.addEventListener("touchmove", this.touch), this.D.addEventListener("touchstart", this.touch)) : this.D.addEventListener("mousemove", this.move);
		}
		draw() {
			requestAnimationFrame(this.draw), this.update();
		}
		resize() {
			(this.win = { W: this.W.innerWidth, H: this.W.innerHeight }), (this.cursor = { x: this.win.W / 2, y: this.win.W / 2 });
		}
		move(t) {
			(this.cursor.x = t.clientX), (this.cursor.y = t.clientY), this.create(this.cursor.x, this.cursor.y, this.colors[Math.floor(Math.random() * this.colors.length)]);
		}
		touch(t) {
			if (t.touches.length > 0) for (var e = 0; e < t.touches.length; e++) this.create(t.touches[e].clientX, t.touches[e].clientY, this.colors[Math.floor(Math.random() * this.colors.length)]);
		}
		create(t, i, a) {
			(this.particle = new e(this.container, this.char, this.time)), this.particle.init(t, i, a), this.particles.push(this.particle);
		}
		update() {
			for (var t = 0; t < this.particles.length; t++) this.particles[t].update();
			for (t = this.particles.length - 1; t >= 0; t--) this.particles[t].time < 0 && (this.particles[t].destroy(), this.particles.splice(t, 1));
		}
		bindAll(t, e) {
			const i = e.length;
			for (let a = 0; a < i; a++) t[e[a]] = t[e[a]].bind(t);
		}
	}
	function s(t, e) {
		for (var i in e) t.style[i] = e[i];
	}
	class e {
		constructor(t, e, i) {
			(this.char = e), (this.time = i), (this.container = t), (this.styles = {});
		}
		init(t, e, i) {
			(this.velocity = { x: (Math.random() < 0.5 ? -1 : 1) * (Math.random() / 2), y: 1 }),
			(this.pos = { x: t - 10, y: e - 20 }),
			(this.styles.color = i),
			(this.element = document.createElement("div")),
			(this.element.textContent = this.char),
			s(this.element, this.styles),
			this.update(),
			document.getElementById(this.container).append(this.element);
		}
		update() {
			(this.pos.x += this.velocity.x), (this.pos.y += this.velocity.y), this.time--, (this.element.style.transform = "translate3d(" + this.pos.x + "px," + this.pos.y + "px, 0) scale(" + this.time / 50 + ")");
		}
		destroy() {
			this.element.remove();
		}
	}
	new t({ el: "cursor", time: 150, character: cursor_symbol, colors: ["#c7a7a0", '#CCC'] });
}